import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'inArray',
  standalone: true,
})
export class InArrayPipe implements PipeTransform {
  transform(value: string, array: string[]): boolean {
    return array.includes(value)
  }
}
